import {z} from 'zod';
import {EntitySchema, IdField} from '#common/models/Entity';

export const SignupRuleSchema = EntitySchema.extend({
  description: z.string().optional(),
  enabled: z.boolean(),
  type: z.enum(['domain', 'exact', 'regex']),
  value: z.string(),
});

export type SignupRule = z.infer<typeof SignupRuleSchema>;

export const SignupRulePrototypeSchema = SignupRuleSchema.omit({
  [IdField]: true,
});

export type SignupRulePrototype = z.infer<typeof SignupRulePrototypeSchema>;
